import React from "react";
import store from "/redux/state";
import CustomButton from "/components/core/ButtonDefault";

import { useWithdrawableBalance } from "/api/user/tico-balance";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";
import { useBuyItem } from "./useBuyItem.hook";
import { useTranslation } from "/utils/hooks/useCustomTranslation";
import { funticoUrl } from "/utils/links";

function getTotalPrize(prizeNumber, quantityNumber) {
  const prize = Number(prizeNumber);
  const quantity = Number(quantityNumber);

  if (typeof prize !== "number" || typeof quantity !== "number") {
    return "";
  }
  return Intl.NumberFormat("en-US", { maximumSignificantDigits: 3 }).format(
    prize * quantity
  );
}

export function ConfirmPopup({
  shopItemId,
  item,
  price,
  quantity,
  priceCurrency,
}) {
  const { trigger, isMutating, data, error } = useBuyItem(shopItemId);
  const axiosClient = useAxiosWithAuth();
  const { mutate } = useWithdrawableBalance(axiosClient);

  if (data) return <SuccessPopup item={item} quantity={quantity} />;
  if (error) return <ErrorPopup />;

  const handlePurchase = async () => {
    await trigger(
      // @ts-ignore
      {
        itemId: item.itemId,
        quantity,
        price,
        priceCurrency,
      },
      {
        onSuccess: () => {
          mutate();
        },
      }
    );
  };

  return (
    <div className="confirm-buy-popup df fd-c ai-c text-center gap-32">
      <div className="title df fd-c jc-c">
        <p className="fixel_26">Confirm Your Purchase</p>

        <img
          className="df fd-c w-full"
          style={{ width: "250px" }}
          src={item.visual}
          alt={item.name}
        />
        <p>You are about to purchase:</p>

        <div className="font-20-sbl title-name df ai-c gap-6">
          <p>
            x{quantity} {item.name}
          </p>
          <div>
            ({" "}
            <div
              className="tico_icon ico"
              style={{ marginBottom: "-5px" }}
            ></div>{" "}
            {getTotalPrize(price, quantity)} )
          </div>
        </div>
        <p>Would you like to proceed?</p>
      </div>
      <div className="corfirm_buttons df jc-c sing">
        <CustomButton
          def={null}
          classname="link def pr type-40 br-16"
          title={"Confirm"}
          onClick={handlePurchase}
          disabled={isMutating}
        />
      </div>
    </div>
  );
}

function SuccessPopup({ item, quantity }) {
  return (
    <>
      <div className="title df fd-c jc-c">
        <div className="image">
          <img
            className="df fd-c w-full"
            style={{ width: "250px" }}
            src={item.visual}
            alt={item.name}
          />
        </div>
        <p className="fixel_36 mr-t-16">Congratulations!</p>
        <p className="mr-t-16">You have acquired</p>
        <p className="font-20-sbl">
          x{quantity} {item.name}
        </p>
        {/* <p>
          You can now find all of the items inside, unbundled in your Backpack,
          on{" "}
          <a href={`${funticoUrl}/`} target="_blank" className="color-sec">
            Funtico.com!
          </a>
        </p> */}
      </div>
      <div className="corfirm_buttons df jc-c sing">
        <CustomButton
          def={null}
          classname="link def pr type-40 br-16"
          title={"Close"}
          onClick={() => {
            store.setPopUp("");
          }}
        />
      </div>
    </>
  );
}

function ErrorPopup() {
  const { t } = useTranslation();
  return (
    <>
      <div className="title df fd-c jc-c">
        <p className="t fixel_36 ">{t("shop.somethingWentWrong")}</p>
        <p className="s">{t("shop.tryAgainLater")}</p>
      </div>
      <div className="corfirm_buttons df jc-c sing">
        <CustomButton
          def={null}
          classname="link def pr type-40 br-16"
          title={t("shop.okay")}
          onClick={() => {
            store.setPopUp("");
          }}
        />
      </div>
    </>
  );
}
